// components/SignatureSection.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/SignatureSection.module.css";
import food1 from "../images/kumquat-salad.jpg";
import food2 from "../images/steak.jpg";
import food3 from "../images/mpakaliaros-skordalia.jpg";

const dishes = [
  {
    title: "Corfu Salad",
    text: "Mixed green salad with nou blo gruyere, fig, kumquat, citrus sauce",
    image: food1,
  },
  {
    title: "Premium Steaks",
    text: "Perfectly grilled meats prepared with authentic Mediterranean character.",
    image: food2,
  },
  {
    title: "Bakaliaros Skordalia",
    text: "Fried cod with creamy garlic potato purée.",
    image: food3,
  },
];

export default function SignatureSection() {
  const navigate = useNavigate();

  return (
    <section className={styles.section} id="menu">
      <div className={styles.container}>
        <span className={styles.subtitle}>
          Signature Experience
        </span>

        <h2>Our Featured Dishes</h2>

        <div className={styles.grid}>
          {dishes.map((dish, index) => (
            <div className={styles.card} key={index}>
              <img src={dish.image} alt={dish.title} />

              <div className={styles.content}>
                <h3>{dish.title}</h3>
                <p>{dish.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* MENU BUTTON */}
        <div className={styles.buttonWrapper}>
          <button
            className={styles.menuButton}
            onClick={() => navigate("/menu")}
          >
            View Full Menu
          </button>
        </div>
      </div>
    </section>
  );
}